import { render, staticRenderFns } from "./cardDetails.vue?vue&type=template&id=5dc8b056&"
import script from "./cardDetails.vue?vue&type=script&lang=js&"
export * from "./cardDetails.vue?vue&type=script&lang=js&"
import style0 from "./cardDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports